<template>
    <div>
        <span class="a-fs-14 a-ptb-10 a-c-333 a-fw-700">电费：</span>
        <el-table ref="electricAddBill" :data="tableData" :span-method='mergeCols' :highlight-current-row="true" :border='true' style="width: 100%">
            <el-table-column prop="projectId" label="电费项目" width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.projectName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="stationId" label="站点" width="140">
                <template slot-scope="{ row }">
                    <el-tag type="primary" size='mini' v-if="row.status== 1">已转移</el-tag>
                    <span>{{ row.stationName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ammeterId" label="电表号" width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.ammeterNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="lastRecordTimeId" label="计费起始时间" width="160">
                <template slot-scope="{ row }">
                    <!-- <span v-if="row.lastRecordTimeReadoOnly">{{ row.lastRecordTime || '-' }}</span> -->
                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="row.lastRecordTime"
                        @change="lastRecordTimeChange"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column prop="recordTimeId" label="计费终止时间" width="160">
                <template slot-scope="{ row }">
                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="row.recordTime"
                        @change="recordTimeChange"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column prop="remainMoneyId" label="剩余费用" min-width="180" v-if="chargeFeeType == 1">
                <template slot-scope="{ row }">
                    <jd-input-price v-model="row.remainMoney" @input='handleInput(row.remainMoney,"remainMoney",row.remainMoneyId,"remainMoneyId")'></jd-input-price>
                </template>
            </el-table-column>
            <el-table-column prop="lastRemainMoneyId" label="上次剩余费用" min-width="100" v-if="chargeFeeType == 1">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.lastRemainMoney) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="prePayAmountId" label="预缴费用" min-width="180" v-if="chargeFeeType == 1">
                <template slot-scope="{ row }">
                    <jd-input-price v-model="row.prePayAmount" @input='handleInput(row.prePayAmount,"prePayAmount",row.prePayAmountId,"prePayAmountId")'></jd-input-price>
                </template>
            </el-table-column>
            <el-table-column prop="lastPrePayAmountId" label="上次预缴费用" min-width="100" v-if="chargeFeeType == 1">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.lastPrePayAmount) }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="recordPowerId" label="本次度数（kwh）" min-width="180" v-if="chargeFeeType == 1">
                <template slot-scope="{ row }">
                    <span>{{ row.recordPower || '-' }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="recordPowerId" label="本次度数（kwh）" min-width="180" >
                <template slot-scope="{ row }">
                    <el-input v-model="row.recordPower" maxlength="24" placeholder="请输入" @input='handleInput(row.recordPower,"recordPower",row.recordPowerId,"recordPowerId")'></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="lastRecordPowerId" label="上次度数（kwh）" min-width="130">
                <template slot-scope="{ row }">
                    <!-- <span>{{ row.lastRecordPower === '' ? '-' : row.lastRecordPower }}</span> -->
                    <el-input v-model="row.lastRecordPower" maxlength="24" placeholder="请输入" @input='handleInput(row.lastRecordPower,"lastRecordPower",row.lastRecordPowerId,"lastRecordPowerId")'></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="needPayAmountId" label="应付电费" min-width="180" v-if="chargeFeeType == 2">
                <template slot-scope="{ row }">
                    <div class="a-flex-cfsfs" style="font-size: 12px;align-items: flex-start">
                        <jd-input-price v-model="row.needPayAmount" @blur='handleBlur(row.needPayAmount,"needPayAmount",row.needPayAmountId,"needPayAmountId")' @input='handleInput(row.needPayAmount,"needPayAmount",row.needPayAmountId,"needPayAmountId")'></jd-input-price>
                        <span class="a-c-999" v-if="row.outsideEnergy">我方电费估算：￥{{ util.numFormat(row.innerPrice || 0) }}</span>
                        <span class="a-c-999" v-if="row.outsideEnergy">他方电费估算：￥{{ util.numFormat(row.outsidePrice || 0) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="needPayAmountId" label="应付电费" min-width="180" v-if="chargeFeeType == 1">
                <template slot="header" slot-scope="scope">
                    <div class="a-flex-rfsc">
                        <span>应付电费</span>
                        <el-tooltip class="item" effect="dark" content="上次预缴费用 + 上次剩余费用 - 剩余费用 = 应付电费" placement="top">
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row }">
                    <div class="a-flex-cfsfs" style="font-size: 12px;align-items: flex-start">
                        <span style="font-size: 14px;">￥{{ util.numFormat(row.needPayAmount) }}</span>
                        <span class="a-c-999" v-if="row.outsideEnergy">我方电费估算：￥{{ util.numFormat(row.innerPrice || 0) }}</span>
                        <span class="a-c-999" v-if="row.outsideEnergy">他方电费估算：￥{{ util.numFormat(row.outsidePrice || 0) }}</span>
                    </div>
                </template>
            </el-table-column>
            
            <el-table-column prop="unitPriceId" label="项目单价（/元/kwh）" min-width="160">
                <template slot-scope="{ row }">
                    <div class="a-flex-cfsfs">
                        <span>￥{{ util.numFormat5(row.unitPrice) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="billUnitPriceId" label="账单单价（/元/kwh）" min-width="160">
                <template slot-scope="{ row }">
                    <div class="a-flex-cfsfs">
                        <span>￥{{ util.numFormat5(row.billUnitPrice) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="intervalIncomeId" label="区间收益" min-width="120">
                <template slot-scope="{ row }">
                    <!-- <span>￥{{ util.numFormat(row.intervalIncome) }}</span> -->
                    <jd-input-price v-model="row.intervalIncome" @blur="handleChangeIntervalIncome" @input='handleInput(row.intervalIncome,"intervalIncome",row.intervalIncomeId,"intervalIncomeId")'></jd-input-price>
                </template>
            </el-table-column>
            <el-table-column prop="stationIncomeRatioId" label="电表区间收益占比" min-width="120">
                <template slot-scope="{ row }">
                    <span>{{ (row.stationIncomeRatio*100).toFixed(2) }}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="totalProfitId" label="收益合计" min-width="120">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.totalProfit) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="totalPayId" label="应付合计" min-width="120">
                <template slot-scope="{ row }">
                    <div class="a-flex-cfsfs" style="font-size: 12px;align-items: flex-start">
                        <span style="font-size: 14px;">￥{{ util.numFormat(row.totalPay) }}</span>
                        <span class="a-c-999" v-if="row.outsideEnergy">我方电费估算：￥{{ util.numFormat(row.innerPriceTotal || 0) }}</span>
                        <span class="a-c-999" v-if="row.outsideEnergy">他方电费估算：￥{{ util.numFormat(row.outsidePriceTotal || 0) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="intervalRatioId" label="区间电费占比" min-width="120">
                <template slot-scope="{ row }">
                    <span>{{ row.intervalRatio || 0 }}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="ratioId" label="项目总电费占比" min-width="130">
                <template slot-scope="{ row }">
                    <span>{{ row.ratio || 0 }}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="deviceNumId" label="设备总数/插槽总数" min-width="120">
                <template slot-scope="{ row }">
                    <!-- <el-input 
                        v-model="row.deviceNumByRadio" 
                        maxlength="24" 
                        placeholder="请输入" 
                        @input='handleInput(row.deviceNumByRadio,"deviceNumByRadio",row.deviceNumId,"deviceNumId")'>
                    </el-input>
                    <span>/</span>
                    <el-input 
                        v-model="row.slotNumByRadio" 
                        maxlength="24" 
                        placeholder="请输入" 
                        @input='handleInput(row.slotNumByRadio,"slotNumByRadio",row.deviceNumId,"deviceNumId")'>
                    </el-input> -->
                    <span>{{ row.deviceNumByRadio || 0 }}/{{ row.slotNumByRadio || 0 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="predictEnergyId" label="抄表电量/估算电量(kwh)" min-width="120">
                <template slot-scope="{ row }">
                    <span>{{ row.inputEnergy || 0 }}/{{ row.predictEnergy || 0 }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="scrollBar">
            <scroll-bar :table-ref="$refs.electricAddBill"></scroll-bar>
        </div>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    import scrollBar from '../../components/table/scrollBar.vue'
    export default {
        components: {
            scrollBar
        },
        data () {
            return {
                debounceTimeout: null,
                util: util,
            }
        },
        props: {
            tableData: {
                default: ()=>{
                    return []
                }
            },
            chargeFeeType: { //电费收取方式:1:预充值,2先用后付
                default: ''
            }
        },
        computed: {
            // 获取所有单元格合并数据
            spanArr() {
                if(!this.tableData.length) return []
                let mergeCols = [] // 需要合并的列（字段）
                // if(this.chargeFeeType == 1) {
                //     mergeCols = ['projectId','stationId','ammeterId','deviceNumId','recordTimeId','lastRecordTimeId','recordPowerId','needPayAmountId','remainMoneyId','prePayAmountId',
                //                 'lastRecordPowerId','lastPrePayAmountId','lastRemainMoneyId','unitPriceId','intervalIncomeId','stationIncomeRatioId',
                //                 'totalProfitId','totalPayId','intervalRatioId','ratioId'] // 需要合并的列（字段）
                // }else if(this.chargeFeeType == 2) {
                //     mergeCols = ['projectId','stationId','ammeterId','deviceNumId','recordTimeId','lastRecordTimeId','recordPowerId','needPayAmountId',
                //                 'lastRecordPowerId','unitPriceId','intervalIncomeId','stationIncomeRatioId',
                //                 'totalProfitId','totalPayId','intervalRatioId','ratioId'] // 需要合并的列（字段）
                // }
                if(this.chargeFeeType == 1) {
                    mergeCols = ['projectId','stationId','ammeterId','recordTimeId','lastRecordTimeId','needPayAmountId',
                                'remainMoneyId','lastRemainMoneyId','prePayAmountId','lastPrePayAmountId','recordPowerId','lastRecordPowerId',
                                'unitPriceId','billUnitPriceId','intervalIncomeId','stationIncomeRatioId',
                                'totalProfitId','totalPayId','intervalRatioId','ratioId','deviceNumId','predictEnergyId'] // 需要合并的列（字段）
                }else if(this.chargeFeeType == 2) {
                    mergeCols = ['projectId','stationId','ammeterId','recordTimeId','lastRecordTimeId','needPayAmountId','recordPowerId','lastRecordPowerId',
                                'unitPriceId','billUnitPriceId','intervalIncomeId','stationIncomeRatioId',
                                'totalProfitId','totalPayId','intervalRatioId','ratioId','deviceNumId','predictEnergyId'] // 需要合并的列（字段）
                }
                return util.getMergeCells(this.tableData, mergeCols, mergeCols)
            }
        },
        methods:{
            handleInput (value, prop, propValue, propId) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = setTimeout(() => {
                    // 防抖处理后的输入内容
                    // lastRemainMoney  上次剩余
                    // lastPrePayAmount  上次预付
                    // RemainMoney  本次剩余
                    let currentOperateAmmeterId = ''
                    try {
                        currentOperateAmmeterId = this.tableData.find(res=>{
                            return res[propId] == propValue
                        }).ammeterId
                    } catch (error) {}
                    let totalIntervalProfitObj = {} //所有站点的区间收益合计按项目
                    let totalIntervalProfit = 0//所有站点的区间收益合计
                    let listByStationId = this.groupById(this.tableData, 'stationId')
                    if(propId == 'deviceNumId') { // 用户修改了设备数 插槽数后 重新计算电表区间收益占比
                        this.tableData.map((item,index)=>{
                            if(item[propId] == propValue) {
                                item[prop] = value
                            }
                            let ratioAll = 0
                            if(listByStationId[item.stationId].length == 1){
                                item.stationIncomeRatio = 1
                                item.slotNum = item.slotNumByRadio
                                item.deviceNum = item.deviceNumByRadio
                            }else{
                                let slotNumAll = 0
                                let deviceNumAll = 0
                                listByStationId[item.stationId].map(ite=>{
                                    slotNumAll += Number(ite.slotNumByRadio || 0)
                                    deviceNumAll += Number(ite.deviceNumByRadio || 0)
                                })
                                if(index<this.tableData.length-1){
                                    item.stationIncomeRatio = Number((item.slotNumByRadio / slotNumAll).toFixed(4))
                                    ratioAll += Number((item.slotNumByRadio / slotNumAll).toFixed(4))
                                }else{
                                    item.stationIncomeRatio = 1 - ratioAll
                                }

                                item.slotNum = slotNumAll
                                item.deviceNum = deviceNumAll
                            }
                        })
                    }

                    if(propId == 'intervalIncomeId') {
                        this.tableData.map((item,index)=>{
                            if(item[propId] == propValue) {
                                item[prop] = value
                            }
                        })
                    }
                    for (const key in listByStationId) {
                        totalIntervalProfit += listByStationId[key][0].intervalIncome ? Number((listByStationId[key][0].intervalIncome * 100).toFixed(0)) : 0
                        let projectId = listByStationId[key][0].projectId
                        // 按项目计算每个项目的收益合计
                        if(totalIntervalProfitObj[projectId]) {
                            totalIntervalProfitObj[projectId] += listByStationId[key][0].intervalIncome ? Number((listByStationId[key][0].intervalIncome * 100).toFixed(0)) : 0
                        }else {
                            totalIntervalProfitObj[projectId] = listByStationId[key][0].intervalIncome ? Number((listByStationId[key][0].intervalIncome * 100).toFixed(0)) : 0
                        }
                    }

                    let uniqArr = JSON.parse(JSON.stringify(this.tableData))
                    uniqArr = this.uniqueArrAmmeter(uniqArr)
                    let totalPay = 0 //所有电表的应付合计
                    let innerPriceTotal = 0 //所有电表的我方估算应付合计
                    let outsidePriceTotal = 0 //所有电表的他方估算应付合计
                    let innerPriceTotalByProject = {} //所有电表的我方估算应付合计(按项目分)
                    let outsidePriceTotalByProject = {} //所有电表的他方估算应付合计(按项目分)
                    let totalPayByProject = {} //所有电表的应付合计(按项目分)
                    let totalIntervalPower = 0 //所有电表的电量度数合计
                    let lastTotalIntervalPower = 0 //所有电表的上次电量度数合计
                    let needPayAmountObj = {} // 存储每一个电表的应付费用，预付时用
                    let currentPowerObj = {} // 存储每一个电表的本次度数，预付时用
                    let innerPriceObj = {} // 存储每一个电表的我方估算电费
                    let outsidePriceObj = {} // 存储每一个电表的他方估算合计
                    let stationAndAmmeterProfitObj = {} // 存储每一个电表对应的站点的收益费用总值，用于计算每一个电表的区间收益占比
                    uniqArr.map(item=>{
                        let estimatedProportion = 0 // 他方应付估算比列
                        if(item.outsideEnergy) {
                            estimatedProportion = item.outsideEnergy / item.predictEnergy // 存在他方预估电量的时候，计算他方占比
                        }
                        if(this.chargeFeeType == 1) {
                            // 计算先付费应付合计
                            if((item.lastRemainMoney || item.lastRemainMoney === 0) && (item.lastPrePayAmount || item.lastPrePayAmount === 0)) {
                                let amount = (Number(item.lastRemainMoney) + Number(item.lastPrePayAmount) - (Number((item.remainMoney*100).toFixed(0)) || 0))
                                // let amount = this.$decimal.decimal_add(Number(item.lastRemainMoney), Number(item.lastPrePayAmount))
                                // amount = this.$decimal.decimal_reduce(amount, (Number((item.remainMoney*100).toFixed(0)) || 0))
                                totalPay += amount
                                if(totalPayByProject[item.projectId]) {
                                    totalPayByProject[item.projectId] += amount
                                }else {
                                    totalPayByProject[item.projectId] = amount
                                }
                                this.$set(needPayAmountObj,item.ammeterId,amount)
                                this.$set(outsidePriceObj,item.ammeterId,(amount * estimatedProportion).toFixed(0))
                                this.$set(innerPriceObj,item.ammeterId,this.$decimal.decimal_reduce(amount, (amount * estimatedProportion).toFixed(0)))
                                if(innerPriceTotalByProject[item.projectId]) {
                                    innerPriceTotalByProject[item.projectId] += this.$decimal.decimal_reduce(amount, (amount * estimatedProportion).toFixed(0))
                                }else {
                                    innerPriceTotalByProject[item.projectId] = this.$decimal.decimal_reduce(amount, (amount * estimatedProportion).toFixed(0))
                                }
                                if(outsidePriceTotalByProject[item.projectId]) {
                                    outsidePriceTotalByProject[item.projectId] += Number((amount * estimatedProportion).toFixed(0))
                                }else {
                                    outsidePriceTotalByProject[item.projectId] = Number((amount * estimatedProportion).toFixed(0))
                                }
                                // innerPriceTotal += this.$decimal.decimal_reduce(amount, (amount * estimatedProportion).toFixed(0))
                                // outsidePriceTotal += Number((amount * estimatedProportion).toFixed(0))
                            }else {
                                totalPay += 0
                                if(totalPayByProject[item.projectId]) {
                                    totalPayByProject[item.projectId] += 0
                                }else {
                                    totalPayByProject[item.projectId] = 0
                                }
                                this.$set(needPayAmountObj,item.ammeterId,0)
                                this.$set(outsidePriceObj,item.ammeterId,0)
                                this.$set(innerPriceObj,item.ammeterId,0)
                                // innerPriceTotal += 0
                                // outsidePriceTotal += 0
                                if(innerPriceTotalByProject[item.projectId]) {
                                    innerPriceTotalByProject[item.projectId] += 0
                                }else {
                                    innerPriceTotalByProject[item.projectId] = 0
                                }

                                if(outsidePriceTotalByProject[item.projectId]) {
                                    outsidePriceTotalByProject[item.projectId] += 0
                                }else {
                                    outsidePriceTotalByProject[item.projectId] = 0
                                }
                            }
                        }else if(this.chargeFeeType == 2) {
                            // 计算应付电费
                            if(propId == 'needPayAmountId'){ 
                                // 如果是用户正在输入应付电费，则以用户输入为准
                                totalPay += (Number(item.needPayAmount*100) || 0)
                                if(totalPayByProject[item.projectId]) {
                                    totalPayByProject[item.projectId] += (Number(item.needPayAmount*100) || 0)
                                }else {
                                    totalPayByProject[item.projectId] = (Number(item.needPayAmount*100) || 0)
                                }
                                this.$set(outsidePriceObj,item.ammeterId,((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                this.$set(innerPriceObj,item.ammeterId,this.$decimal.decimal_reduce((Number(item.needPayAmount*100) || 0), ((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0)))
                                // innerPriceTotal += this.$decimal.decimal_reduce((Number(item.needPayAmount*100) || 0), ((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                // outsidePriceTotal += Number(((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                if(innerPriceTotalByProject[item.projectId]) {
                                    innerPriceTotalByProject[item.projectId] += this.$decimal.decimal_reduce((Number(item.needPayAmount*100) || 0), ((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                }else {
                                    innerPriceTotalByProject[item.projectId] = this.$decimal.decimal_reduce((Number(item.needPayAmount*100) || 0), ((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                }

                                if(outsidePriceTotalByProject[item.projectId]) {
                                    outsidePriceTotalByProject[item.projectId] += Number(((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                }else {
                                    outsidePriceTotalByProject[item.projectId] = Number(((Number(item.needPayAmount*100) || 0) * estimatedProportion).toFixed(0))
                                }
                            }else if(item.recordPower !== '' && item.recordPower !== null && item.lastRecordPower !== '' && item.lastRecordPower !== null && item.unitPrice) {
                                // 如果不是用户输入的应付电费，则以上次度数和本次度数之差*电费单价为准
                                let amount = (Number(item.recordPower || 0) - Number(item.lastRecordPower || 0)) * Number(item.unitPrice || 0)
                                // 计算后付费应付合计
                                amount = Number((amount / 100).toFixed(2))
                                totalPay += Number((amount*100).toFixed(0))
                                if(totalPayByProject[item.projectId]) {
                                    totalPayByProject[item.projectId] += Number((amount*100).toFixed(0))
                                }else {
                                    totalPayByProject[item.projectId] = Number((amount*100).toFixed(0))
                                }
                                this.$set(needPayAmountObj,item.ammeterId,amount)
                                this.$set(outsidePriceObj,item.ammeterId,(Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))
                                this.$set(innerPriceObj,item.ammeterId,this.$decimal.decimal_reduce(Number((amount*100).toFixed(0)), (Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0)))
                                // innerPriceTotal += this.$decimal.decimal_reduce(Number((amount*100).toFixed(0)), (Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))
                                // outsidePriceTotal += Number((Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))

                                if(innerPriceTotalByProject[item.projectId]) {
                                    innerPriceTotalByProject[item.projectId] += this.$decimal.decimal_reduce(Number((amount*100).toFixed(0)), (Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))
                                }else {
                                    innerPriceTotalByProject[item.projectId] = this.$decimal.decimal_reduce(Number((amount*100).toFixed(0)), (Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))
                                }

                                if(outsidePriceTotalByProject[item.projectId]) {
                                    outsidePriceTotalByProject[item.projectId] += Number((Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))
                                }else {
                                    outsidePriceTotalByProject[item.projectId] = Number((Number((amount*100).toFixed(0)) * estimatedProportion).toFixed(0))
                                }
                            }else{
                                totalPay += 0
                                if(totalPayByProject[item.projectId]) {
                                    totalPayByProject[item.projectId] += 0
                                }else {
                                    totalPayByProject[item.projectId] = 0
                                }
                                this.$set(needPayAmountObj,item.ammeterId,0)
                                this.$set(outsidePriceObj,item.ammeterId,0)
                                this.$set(innerPriceObj,item.ammeterId,0)
                                // innerPriceTotal += 0
                                // outsidePriceTotal += 0
                                if(innerPriceTotalByProject[item.projectId]) {
                                    innerPriceTotalByProject[item.projectId] += 0
                                }else {
                                    innerPriceTotalByProject[item.projectId] = 0
                                }
                                if(outsidePriceTotalByProject[item.projectId]) {
                                    outsidePriceTotalByProject[item.projectId] += 0
                                }else {
                                    outsidePriceTotalByProject[item.projectId] = 0
                                }
                            }
                        }
                        if(propId == 'recordPowerId'){ 
                            // 如果是用户正在输入本次度数，则以用户输入为准
                            this.$set(currentPowerObj,item.ammeterId,item.recordPower)
                        }else {
                            // 这里先屏蔽，不再做电费和度数强关联
                            // let currentPower
                            // if(needPayAmountObj[item.ammeterId] && item.unitPrice) {
                            //     currentPower = parseInt(needPayAmountObj[item.ammeterId] / item.unitPrice + (item.lastRecordPower || 0))
                            // }else {
                            //     currentPower = ''
                            // }
                            // this.$set(currentPowerObj,item.ammeterId,currentPower || currentPower === 0 ? JSON.stringify(currentPower) : '')
                            this.$set(currentPowerObj,item.ammeterId,item.recordPower)
                        }
                        totalIntervalPower += Number(item.recordPower || 0)
                        lastTotalIntervalPower += Number(item.lastRecordPower || 0)

                        // 计算每一个电表对应的站点的区间收益总值
                        let stationAndAmmeterIncome = 0
                        let stationAndAmmeterIncomeList = this.tableData.filter(res=>{ // 筛选出每一个电表对应的所有站点集合
                            return res.ammeterId == item.ammeterId
                        })
                        stationAndAmmeterIncomeList.map(ite=>{  //将筛选出的站点集合循环，计算出站点集合的总区间收益
                            stationAndAmmeterIncome += (Number(ite.intervalIncome?(ite.intervalIncome*100).toFixed(0):0) * Number(ite.stationIncomeRatio))
                        })
                        this.$set(stationAndAmmeterProfitObj,item.ammeterId,stationAndAmmeterIncome)

                    })
                    this.tableData.map((item,index)=>{
                        if(item[propId] == propValue) {
                            item[prop] = value
                        }
                        item.totalPayAllProject = totalPay //所有电表的应付合计
                        item.totalPay = totalPayByProject[item.projectId] //所有电表的应付合计
                        item.totalIntervalPower = totalIntervalPower //所有电表的电量度数合计
                        item.lastTotalIntervalPower = lastTotalIntervalPower //所有电表的电量度数合计
                        item.totalProfitAllProject = totalIntervalProfit
                        item.totalProfit = totalIntervalProfitObj[item.projectId]
                        item.inputEnergy = this.$decimal.decimal_reduce((item.recordPower || 0), (item.lastRecordPower || 0))
                        
                        if(propId != 'intervalIncomeId' && (currentOperateAmmeterId == item.ammeterId || !currentOperateAmmeterId)){
                            item.innerPrice = innerPriceObj[item.ammeterId]  // 我方应付预估
                            item.outsidePrice = outsidePriceObj[item.ammeterId]  // 他方应付预估
                            item.innerPriceTotal = innerPriceTotalByProject[item.projectId]
                            item.outsidePriceTotal = outsidePriceTotalByProject[item.projectId]
                        }
                        

                        if(propId != 'needPayAmountId' && propId != 'intervalIncomeId' && currentOperateAmmeterId == item.ammeterId){
                            item['needPayAmount'] = needPayAmountObj[item.ammeterId]
                        }
                        if(propId != 'recordPowerId'){
                            item['recordPower'] = currentPowerObj[item.ammeterId]
                        }
                        //计算区间收益电费占比
                        if((item.needPayAmount || item.needPayAmount === 0 || item.needPayAmount === '0') && stationAndAmmeterProfitObj[item.ammeterId]){ 
                            // 每一个电表的应付金额 / 每一个电表（站点集合）的区间收益 = 该电表的区间收益占比
                            if(this.chargeFeeType == 1) {
                                item.intervalRatio = parseInt((Number(item.needPayAmount) / Number(stationAndAmmeterProfitObj[item.ammeterId]))*10000)/100
                            }else{
                                item.intervalRatio = parseInt((Number(item.needPayAmount * 100) / Number(stationAndAmmeterProfitObj[item.ammeterId]))*10000)/100
                            }
                        } else if(Number(item.needPayAmount) && !Number(stationAndAmmeterProfitObj[item.ammeterId]) ){//&& stationAndAmmeterProfitObj[item.ammeterId] !== 0 && stationAndAmmeterProfitObj[item.ammeterId] !== '0'
                            item.intervalRatio = 100
                        } else {
                            item.intervalRatio = 0
                        }
                        // 计算项目总电费占比
                        if((item.totalPay || item.totalPay === 0 || item.totalPay === '0') && item.totalProfit) {
                            item.ratio = parseInt((Number(item.totalPay) / Number(item.totalProfit))*10000)/100
                        }else if(Number(item.totalPay) && !Number(item.totalProfit) ) {//&& item.totalProfit !== '0' && item.totalProfit !== 0
                            item.ratio = 100
                        }else {
                            item.ratio = 0
                        }

                        // 计算账单单价
                        let powerAll = this.$decimal.decimal_reduce(totalIntervalPower, lastTotalIntervalPower)
                        if(powerAll > 0) {
                            this.$set(item, 'billUnitPrice', this.$decimal.decimal_except(item.totalPayAllProject, powerAll))
                        }else {
                            this.$set(item, 'billUnitPrice', item.unitPrice)
                        }
                    })
                    this.$emit('update:tableData', this.tableData)
                }, 100);
            },
            handleBlur (value, prop, propValue, propId) {
                this.tableData.map((item,index)=>{
                    if(propId == 'needPayAmountId') {
                        // 如果用户输入了应付电费，并且上次本次电表度数为空时，反算出电表度数
                        if(!item.recordPower && item.recordPower !== 0 && item.recordPower !== '0' && item.lastRecordPower && item.needPayAmount) {
                            let unitPrice = this.$decimal.decimal_except(item.unitPrice, 100) //单价：元
                            let intervalPower = this.$decimal.decimal_except(item.needPayAmount, unitPrice) // 区间度数
                            let recordPower = this.$decimal.decimal_add(item.lastRecordPower, intervalPower) // 上次度数
                            item.recordPower = recordPower.toFixed(2)
                        }
                    }
                })
                this.$nextTick(()=>{
                    this.handleInput(value, prop, propValue, propId)
                })
            },
            recordTimeChange (val) {
                this.tableData.map(item=>{
                    item.recordTime = val
                })
                this.$emit('update:tableData', this.tableData)
                this.$emit('recordTimeChange',val)
            },
            lastRecordTimeChange (val) {
                this.tableData.map(item=>{
                    item.lastRecordTime = val
                })
                this.$emit('update:tableData', this.tableData)
                this.$emit('lastRecordTimeChange',val)
            },
            handleChangeIntervalIncome (val) {
                this.$emit('intervalIncomeChange',val)
            },
            // 合并行
            mergeCols ({ row, column, rowIndex, columnIndex }) {
                return this.spanArr[rowIndex][columnIndex]
            },
            groupById(arr,key) {
                const result = {};
                arr.forEach(item => {
                    if (!result[item[key]]) {
                    result[item[key]] = [];
                    }
                    result[item[key]].push(item);
                });
                return result;
            },
            //数组去重
            uniqueArr (arr) {
                try{
                    for(var i=0; i<arr.length; i++){
                        for(var j=i+1; j<arr.length; j++){
                            if(arr[i].stationId==arr[j].stationId){         //第一个等同于第二个，splice方法删除第二个
                                arr.splice(j,1);
                                j--;
                            }
                        }
                    }
                    return arr;
                }catch(err){
                }
            },
            uniqueArrAmmeter (arr) {
                try{
                    for(var i=0; i<arr.length; i++){
                        for(var j=i+1; j<arr.length; j++){
                            if(arr[i].ammeterId==arr[j].ammeterId){         //第一个等同于第二个，splice方法删除第二个
                                arr.splice(j,1);
                                j--;
                            }
                        }
                    }
                    return arr;
                }catch(err){
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.scrollBar{
    width: 100%;
    // left: 200px ;
    // right: 48px ;
    // position: fixed;
    // bottom: 70px;
    background: #fff;
    // z-index: 100;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0px !important;
    height: 0px !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
/deep/ .el-input-group__prepend{
    height: 32px;
    line-height: 32px;
}
/deep/ .el-date-editor.el-input{
    width: 140px !important;
}
</style>